import { Platform } from 'react-native';
import { supabase } from '../../shared/supabase/supabaseClient';
import { trackGA4Event } from '../../shared/analytics/ga4';
import type { CreceFunnelEvent } from '../../../../../shared/crece-funnel';

/**
 * Envía evento del funnel Crece:
 * - RPC track_crece_funnel_event → billing.crece_funnel_events (todas las plataformas;
 *   GA4 no llega a iOS/Android). Fire-and-forget: nunca bloquea ni rompe la UI.
 * - GA4 (gtag) solo en web, no-op si no está inicializado.
 */
export function trackCreceFunnel(
  name: CreceFunnelEvent,
  params?: Record<string, unknown>,
): void {
  trackGA4Event(name, { funnel: 'crece', ...params });
  void supabase
    .rpc('track_crece_funnel_event', {
      p_event_name: name,
      p_params: { platform: Platform.OS, ...params },
    })
    .then(({ error }) => {
      if (error && __DEV__) {
        console.warn('[crece-funnel] rpc', error.message);
      }
    });
  if (__DEV__) {
    console.info('[crece-funnel]', name, params ?? {});
  }
}
